import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import {DataTableModule,SharedModule, ButtonModule, GrowlModule, InputTextModule,
DropdownModule, ConfirmDialogModule} from 'primeng/primeng';

import { ArticleRoutingModule } from './article-routing.module';
import { ArticleComponent } from './article.component';
import { ArticleDetailComponent } from '../article-detail/article-detail.component';
import { ArticleService } from './article.service';


@NgModule({
  imports: [
    CommonModule,
    ArticleRoutingModule,
    DataTableModule,
    SharedModule, ButtonModule, GrowlModule,InputTextModule,
    DropdownModule,
    FormsModule, ConfirmDialogModule
  ],
  declarations: [ArticleComponent, ArticleDetailComponent],
  providers: [ArticleService]
})
export class ArticleModule { }



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/article/article.module.ts